import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import {
  fetchCasteOptions,
  fetchEducationData,
  fetchMultiKulam,
  fetchMultiRaasi,
  fetchMultiStar,
  fetchOccupations,
} from "../apis";
import "./modern-forms.css";
import Load from "../Loading/Load";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "auto",
    minHeight: "40px",
    borderRadius: "10px",
    boxShadow: "none",
    borderColor: "#e1e1e1",
    backgroundColor: "#f9f9f9",
    '&:hover': {
      borderColor: "#e84393"
    }
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: "9999",
    borderRadius: "8px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
    overflowY: "scroll",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#f0f0f0",
    borderRadius: "6px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#333",
    ':hover': {
      backgroundColor: "#e84393",
      color: "white",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#e84393" : state.isFocused ? "#f9e7f4" : "white",
    ':active': {
      backgroundColor: "#e84393",
    }
  })
};

function ModernPartnerPreferenceDetails() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [age, setAge] = useState({ min: "", max: "" });
  const [height, setHeight] = useState({ min: "", max: "" });
  const [weight, setWeight] = useState("");
  const [marital, setMarital] = useState([]);
  const [education, setEducation] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [income, setIncome] = useState({ min: "", max: "" });
  const [religion, setReligion] = useState("");
  const [caste, setCaste] = useState([]);
  const [kulam, setKulam] = useState([]);
  const [star, setStar] = useState([]);
  const [raasi, setRaasi] = useState([]);
  const [chevvai, setChevvai] = useState("");
  const [food, setFood] = useState("");
  const [smoking, setSmoking] = useState("");
  const [drinking, setDrinking] = useState("");
  const [location, setLocation] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const [occupationOptions, setOccupationOptions] = useState([]);
  const [casteOptions, setCasteOptions] = useState([]);
  const [kulamOptions, setKulamOptions] = useState([]);
  const [starOptions, setStarOptions] = useState([]);
  const [raasiOptions, setRaasiOptions] = useState([]);

  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 8;

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  useEffect(() => {
    // Set default values for income if it's empty
    if (!income.min && !income.max) {
      setIncome({
        min: "",
        max: ""
      });
    }
    
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      
      // Fetch all options
      const educationData = await fetchEducationData();
      const occupationData = await fetchOccupations();
      
      // Fetch caste data directly with a more robust approach
      let casteData = [];
      try {
        const casteResponse = await axios.get(`${API_BASE_URL}/api/caste`);
        console.log('Direct caste API response:', casteResponse.data);
        
        // Handle different possible response structures
        if (Array.isArray(casteResponse.data)) {
          casteData = casteResponse.data;
        } else if (casteResponse.data && typeof casteResponse.data === 'object') {
          // If it's an object with a data property
          casteData = casteResponse.data.data || casteResponse.data.castes || [];
        }
        
        // Manually create options if the structure is unexpected
        if (casteData.length === 0) {
          casteData = [
            { id: 1, castename: 'Brahmin' },
            { id: 2, castename: 'Kshatriya' },
            { id: 3, castename: 'Vaishya' },
            { id: 4, castename: 'Shudra' },
            { id: 5, castename: 'Scheduled Caste' },
            { id: 6, castename: 'Scheduled Tribe' },
            { id: 7, castename: 'Other' }
          ];
        }
      } catch (casteError) {
        console.error('Error fetching caste data:', casteError);
        // Fallback caste options
        casteData = [
          { id: 1, castename: 'Brahmin' },
          { id: 2, castename: 'Kshatriya' },
          { id: 3, castename: 'Vaishya' },
          { id: 4, castename: 'Shudra' },
          { id: 5, castename: 'Scheduled Caste' },
          { id: 6, castename: 'Scheduled Tribe' },
          { id: 7, castename: 'Other' }
        ];
      }
      
      const kulamData = await fetchMultiKulam();
      const starData = await fetchMultiStar();
      const raasiData = await fetchMultiRaasi();

      console.log('Partner Preference API Data:', { 
        educationData, 
        occupationData, 
        casteData, 
        kulamData, 
        starData, 
        raasiData 
      });

      // Transform education options
      if (educationData && educationData.length > 0) {
        setEducationOptions(
          educationData.map((edu) => ({
            value: edu.value || edu.Education || edu.education || edu.id,
            label: edu.label || edu.Education || edu.education || edu.name
          }))
        );
      }

      // Transform occupation options
      if (occupationData && occupationData.length > 0) {
        setOccupationOptions(
          occupationData.map((occ) => ({
            value: occ.value || occ.occupation || occ.id,
            label: occ.label || occ.occupation || occ.name
          }))
        );
      }

      // Transform caste options
      setCasteOptions(
        casteData.map((caste) => ({
          value: caste.value || caste.castename || caste.caste || caste.id || caste,
          label: caste.label || caste.castename || caste.caste || caste.name || caste
        }))
      );

      // Transform kulam options
      if (kulamData && kulamData.length > 0) {
        setKulamOptions(
          kulamData.map((kulam) => ({
            value: kulam.value || kulam.kulam || kulam.id,
            label: kulam.label || kulam.kulam || kulam.name
          }))
        );
      }

      // Transform star options
      if (starData && starData.length > 0) {
        setStarOptions(
          starData.map((star) => ({
            value: star.value || star.natchaname || star.id,
            label: star.label || star.natchaname || star.name
          }))
        );
      }

      // Transform raasi options
      if (raasiData && raasiData.length > 0) {
        setRaasiOptions(
          raasiData.map((raasi) => ({
            value: raasi.value || raasi.rasiname || raasi.id,
            label: raasi.label || raasi.rasiname || raasi.name
          }))
        );
      }
    } catch (error) {
      console.error('Error fetching partner preference options:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMaritalChange = (selectedOptions) => {
    console.log('Marital change:', selectedOptions);
    setMarital(selectedOptions || []);
  };

  const handleEducationChange = (selectedOptions) => {
    console.log('Education change:', selectedOptions);
    setEducation(selectedOptions || []);
  };

  const handleOccupationChange = (selectedOptions) => {
    console.log('Occupation change:', selectedOptions);
    setOccupation(selectedOptions || []);
  };

  const handleCasteChange = (selectedOptions) => {
    console.log('Caste change:', selectedOptions);
    setCaste(selectedOptions || []);
  };

  const handleKulamChange = (selectedOptions) => {
    console.log('Kulam change:', selectedOptions);
    setKulam(selectedOptions || []);
  };

  const handleStarChange = (selectedOptions) => {
    console.log('Star change:', selectedOptions);
    setStar(selectedOptions || []);
  };

  const handleRaasiChange = (selectedOptions) => {
    console.log('Raasi change:', selectedOptions);
    setRaasi(selectedOptions || []);
  };

  const handleAgeChange = (field, value) => {
    // Allow any input, including empty strings
    setAge(prev => ({ ...prev, [field]: value }));
  };

  const handleHeightChange = (field, value) => {
    console.log(`Height ${field} change:`, value);
    setHeight(prev => ({ ...prev, [field]: value }));
  };

  const handleWeightChange = (value) => {
    console.log(`Weight change:`, value);
    setWeight(value);
  };

  const handleIncomeChange = (field, value) => {
    console.log(`Income ${field} change:`, value);
    // Create a new object to ensure React detects the state change
    const newIncome = { ...income };
    newIncome[field] = value;
    console.log('New income state:', newIncome);
    setIncome(newIncome);
  };

  const handleReligionChange = (value) => {
    console.log('Religion change:', value);
    setReligion(value);
  };

  const handleChevvaiChange = (value) => {
    console.log('Chevvai change:', value);
    setChevvai(value);
  };

  const handleFoodChange = (value) => {
    console.log('Food change:', value);
    setFood(value);
  };

  const handleSmokingChange = (value) => {
    console.log('Smoking change:', value);
    setSmoking(value);
  };

  const handleDrinkingChange = (value) => {
    console.log('Drinking change:', value);
    setDrinking(value);
  };

  const handleLocationChange = (value) => {
    console.log('Location change:', value);
    setLocation(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      // Extract values from the selected options
      const selectedMarital = marital.length > 0 ? marital[0].value : '';
      const selectedEducation = education.map(edu => edu.value);
      const selectedOccupation = occupation.length > 0 ? occupation[0].value : '';
      const selectedCaste = caste.length > 0 ? caste[0].value : '';
      const selectedKulam = kulam.map(k => k.value);
      const selectedStar = star.map(s => s.value);
      const selectedRaasi = raasi.map(r => r.value);

      // Check for required fields
      const missingFields = [];
      if (!age.min || !age.max) missingFields.push("Age Range");
      if (marital.length === 0) missingFields.push("Marital Status");
      if (!location) missingFields.push("Mother Tongue");
      if (education.length === 0) missingFields.push("Education");
      if (occupation.length === 0) missingFields.push("Occupation");
      if (!chevvai) missingFields.push("Employment Type");
      if (!income.min) missingFields.push("Annual Income");
      if (!religion) missingFields.push("Religion");
      if (caste.length === 0) missingFields.push("Caste");
      if (kulam.length === 0) missingFields.push("Kulam");
      if (star.length === 0) missingFields.push("Star");
      if (raasi.length === 0) missingFields.push("Raasi");
      if (!height.min) missingFields.push("Height Range");
      if (!weight) missingFields.push("Weight Range");
      if (!food) missingFields.push("Body Type");
      // if (!smoking) missingFields.push("Complexion");
      if (!drinking) missingFields.push("Physical Status");

      // If any required fields are missing, show alert and return
      if (missingFields.length > 0) {
        setLoading(false);
        alert(`Please fill in all required fields: ${missingFields.join(", ")}`);
        return;
      }

      // Create a request object that matches what the server expects
      const requestData = {
        user, // Include user information
        pMinAge: age.min,
        pMaxAge: age.max,
        pmarital: selectedMarital,
        peducation: selectedEducation,
        employ: chevvai || '', // Employment type
        mtongue: location || '', // Mother tongue
        occupa: selectedOccupation,
        monincome: income.min || '', // Annual income
        preligion: religion || '',
        pcaste: selectedCaste,
        pkulam: selectedKulam,
        pstar: selectedStar,
        praasi: selectedRaasi,
        pheight: height.min || '',
        pweight: weight || '', // Weight
        pbodytype: food || '', // Body type
        // pcomplexion: smoking || '', // Complexion
        pphysical: drinking || '' // Physical status
      };

      console.log('Sending data to server:', requestData);

      // Use the original endpoint and POST method as in the old form
      const response = await axios.post(
        `${API_BASE_URL}/api/PartnerPreferenceDetails`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }
      );

      console.log("Partner preference API response:", response.data);

      if (response.data.auth) { // Check for auth property in response
        // Reset form fields
        setAge({ min: "", max: "" });
        setHeight({ min: "", max: "" });
        setWeight("");
        setMarital([]);
        setEducation([]);
        setOccupation([]);
        setIncome({ min: "", max: "" });
        setReligion("");
        setCaste([]);
        setKulam([]);
        setStar([]);
        setRaasi([]);
        setChevvai("");
        setFood("");
        // setSmoking("");
        setDrinking("");
        setLocation("");
        
        // Navigate to horoscope page as in the original form
        navigate("/modern-horoscope", { replace: true });
      } else {
        setLoading(false);
        alert("Error: " + (response.data.message || "Failed to save partner preferences"));
      }
    } catch (error) {
      console.error("Error submitting partner preferences:", error);
      setLoading(false);
      
      if (error.response) {
        console.error("Error response data:", error.response.data);
        alert(`Server error (${error.response.status}): ${error.response.data || 'Please try again later.'}`);
      } else if (error.request) {
        alert("No response received from server. Please check your connection.");
      } else {
        alert(`Error: ${error.message}`);
      }
    }
  };

  const maritalOptions = [
    { value: "never_married", label: "Never Married" },
    { value: "divorced", label: "Divorced" },
    { value: "widowed", label: "Widowed" },
    { value: "awaiting_divorce", label: "Awaiting Divorce" },
  ];

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Enhanced Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "\u2713" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                    {i + 1 === 9 && "Horoscope"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <div className="form-header-content">
            <h2 className="profile-form-title">Partner Preferences</h2>
            <p className="profile-form-subtitle">Tell us what you're looking for in your ideal life partner</p>
            <div className="form-header-info">
              <div className="info-badge">
                <span className="info-icon">ℹ️</span>
                <span className="info-text">Your preferences help us find the most compatible matches</span>
              </div>
              {/* <p className="required-fields-note">All fields are mandatory</p> */}
            </div>
          </div>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-section-title">Basic Preferences</div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Age Range</label>
                  <div className="range-inputs">
                    <select
                      className="form-control"
                      value={age.min}
                      onChange={(e) => handleAgeChange('min', e.target.value)}
                      required
                    >
                      <option value="">Min Age</option>
                      {Array.from({ length: 53 }, (_, i) => i + 18).map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                    <span className="range-separator">to</span>
                    <select
                      className="form-control"
                      value={age.max}
                      onChange={(e) => handleAgeChange('max', e.target.value)}
                      required
                    >
                      <option value="">Max Age</option>
                      {Array.from({ length: 53 }, (_, i) => i + 18).map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Height Range</label>
                  <div className="range-inputs">
                    <select
                      className="form-control"
                      value={height.min}
                      onChange={(e) => handleHeightChange('min', e.target.value)}
                      required
                    >
                      <option value="">Min</option>
                      <option value="4ft 5in">4ft 5in</option>
                      <option value="4ft 6in">4ft 6in</option>
                      <option value="4ft 7in">4ft 7in</option>
                      <option value="4ft 8in">4ft 8in</option>
                      <option value="4ft 9in">4ft 9in</option>
                      <option value="4ft 10in">4ft 10in</option>
                      <option value="4ft 11in">4ft 11in</option>
                      <option value="5ft 0in">5ft 0in</option>
                      <option value="5ft 1in">5ft 1in</option>
                      <option value="5ft 2in">5ft 2in</option>
                      <option value="5ft 3in">5ft 3in</option>
                      <option value="5ft 4in">5ft 4in</option>
                      <option value="5ft 5in">5ft 5in</option>
                      <option value="5ft 6in">5ft 6in</option>
                      <option value="5ft 7in">5ft 7in</option>
                      <option value="5ft 8in">5ft 8in</option>
                      <option value="5ft 9in">5ft 9in</option>
                      <option value="5ft 10in">5ft 10in</option>
                      <option value="5ft 11in">5ft 11in</option>
                      <option value="6ft 0in">6ft 0in</option>
                      <option value="6ft 1in">6ft 1in</option>
                      <option value="6ft 2in">6ft 2in</option>
                      <option value="6ft 3in">6ft 3in</option>
                      <option value="6ft 4in">6ft 4in</option>
                      <option value="6ft 5in">6ft 5in</option>
                      <option value="6ft 6in">6ft 6in</option>
                    </select>
                    <span className="range-separator">to</span>
                    <select
                      className="form-control"
                      value={height.max}
                      onChange={(e) => handleHeightChange('max', e.target.value)}
                      required
                    >
                      <option value="">Max</option>
                      <option value="4ft 5in">4ft 5in</option>
                      <option value="4ft 6in">4ft 6in</option>
                      <option value="4ft 7in">4ft 7in</option>
                      <option value="4ft 8in">4ft 8in</option>
                      <option value="4ft 9in">4ft 9in</option>
                      <option value="4ft 10in">4ft 10in</option>
                      <option value="4ft 11in">4ft 11in</option>
                      <option value="5ft 0in">5ft 0in</option>
                      <option value="5ft 1in">5ft 1in</option>
                      <option value="5ft 2in">5ft 2in</option>
                      <option value="5ft 3in">5ft 3in</option>
                      <option value="5ft 4in">5ft 4in</option>
                      <option value="5ft 5in">5ft 5in</option>
                      <option value="5ft 6in">5ft 6in</option>
                      <option value="5ft 7in">5ft 7in</option>
                      <option value="5ft 8in">5ft 8in</option>
                      <option value="5ft 9in">5ft 9in</option>
                      <option value="5ft 10in">5ft 10in</option>
                      <option value="5ft 11in">5ft 11in</option>
                      <option value="6ft 0in">6ft 0in</option>
                      <option value="6ft 1in">6ft 1in</option>
                      <option value="6ft 2in">6ft 2in</option>
                      <option value="6ft 3in">6ft 3in</option>
                      <option value="6ft 4in">6ft 4in</option>
                      <option value="6ft 5in">6ft 5in</option>
                      <option value="6ft 6in">6ft 6in</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Marital Status</label>
                  <select
                    className="form-control"
                    value={marital.length > 0 ? marital[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = maritalOptions.find(option => option.value === selectedValue);
                        handleMaritalChange([selectedOption]);
                      } else {
                        handleMaritalChange([]);
                      }
                    }}
                    required
                  >
                    <option value="">Select Marital Status</option>
                    {maritalOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Mother Tongue</label>
                  <select
                    className="form-control"
                    value={location}
                    onChange={(e) => handleLocationChange(e.target.value)}
                    required
                  >
                    <option value="">Mother Tongue</option>
                    <option value="Tamil">Tamil</option>
                    <option value="Telugu">Telugu</option>
                    <option value="Malayalam">Malayalam</option>
                    <option value="Kannada">Kannada</option>
                    <option value="Hindi">Hindi</option>
                    <option value="Marathi">Marathi</option>
                    <option value="Gujarati">Gujarati</option>
                    <option value="Bengali">Bengali</option>
                    <option value="Punjabi">Punjabi</option>
                    <option value="Urdu">Urdu</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-section-title">Education & Career</div>
            <div className="form-group">
              <label className="form-label">Education</label>
              <select
                className="form-control"
                value={education.length > 0 ? education[0].value : ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  if (selectedValue) {
                    const selectedOption = educationOptions.find(option => option.value === selectedValue);
                    handleEducationChange([selectedOption]);
                  } else {
                    handleEducationChange([]);
                  }
                }}
                required
              >
                <option value="">Select Education</option>
                {educationOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Occupation</label>
                  <select
                    className="form-control"
                    value={occupation.length > 0 ? occupation[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = occupationOptions.find(option => option.value === selectedValue);
                        handleOccupationChange([selectedOption]);
                      } else {
                        handleOccupationChange([]);
                      }
                    }}
                    
                  >
                    <option value="">Select Occupation</option>
                    {occupationOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Employment Type</label>
                  <select
                    className="form-control"
                    value={chevvai}
                    onChange={(e) => handleChevvaiChange(e.target.value)}
                    
                  >
                    <option value="">Employment Type</option>
                    <option value="Government">Government</option>
                    <option value="Private">Private</option>
                    <option value="Business">Business</option>
                    <option value="Self Employed">Self Employed</option>
                    <option value="Not Working">Not Working</option>
                    <option value="Any">Any</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Annual Income</label>
              <select
                className="form-control"
                value={income.min}
                onChange={(e) => handleIncomeChange('min', e.target.value)}
                
              >
                <option value="">Select Annual Income</option>
                <option value="0-1 lakh">0-1 lakh</option>
                <option value="1-2 lakh">1-2 lakh</option>
                <option value="2-3 lakh">2-3 lakh</option>
                <option value="3-4 lakh">3-4 lakh</option>
                <option value="4-5 lakh">4-5 lakh</option>
                <option value="5-6 lakh">5-6 lakh</option>
                <option value="6-7 lakh">6-7 lakh</option>
                <option value="7-8 lakh">7-8 lakh</option>
                <option value="8-9 lakh">8-9 lakh</option>
                <option value="9-10 lakh">9-10 lakh</option>
                <option value="10-15 lakh">10-15 lakh</option>
                <option value="15-20 lakh">15-20 lakh</option>
                <option value="20-25 lakh">20-25 lakh</option>
                <option value="25-50 lakh">25-50 lakh</option>
                <option value="50-75 lakh">50-75 lakh</option>
                <option value="75-1 crore">75-1 crore</option>
                <option value="1 crore & above">1 crore & above</option>
                <option value="Any">Any</option>
              </select>
            </div>

            <div className="form-section-title">Religious Background</div>
            <div className="form-group">
              <label className="form-label">Religion</label>
              <select
                className="form-control"
                value={religion}
                onChange={(e) => handleReligionChange(e.target.value)}
                required
              >
                <option value="">Select Religion</option>
                <option value="Hindu">Hindu</option>
                <option value="Muslim">Muslim</option>
                <option value="Christian">Christian</option>
                <option value="Sikh">Sikh</option>
                <option value="Buddhist">Buddhist</option>
                <option value="Jain">Jain</option>
                <option value="Parsi">Parsi</option>
                <option value="Jewish">Jewish</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Caste</label>
                  <select
                    className="form-control"
                    value={caste.length > 0 ? caste[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = casteOptions.find(option => option.value === selectedValue);
                        handleCasteChange([selectedOption]);
                      } else {
                        handleCasteChange([]);
                      }
                    }}
                    
                  >
                    <option value="">Select Caste</option>
                    {casteOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Kulam</label>
                  <select
                    className="form-control"
                    value={kulam.length > 0 ? kulam[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = kulamOptions.find(option => option.value === selectedValue);
                        handleKulamChange([selectedOption]);
                      } else {
                        handleKulamChange([]);
                      }
                    }}
                    required
                  >
                    <option value="">Select Kulam</option>
                    {kulamOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Star</label>
                  <select
                    className="form-control"
                    value={star.length > 0 ? star[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = starOptions.find(option => option.value === selectedValue);
                        handleStarChange([selectedOption]);
                      } else {
                        handleStarChange([]);
                      }
                    }}
                    required
                  >
                    <option value="">Select Star</option>
                    {starOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Raasi</label>
                  <select
                    className="form-control"
                    value={raasi.length > 0 ? raasi[0].value : ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        const selectedOption = raasiOptions.find(option => option.value === selectedValue);
                        handleRaasiChange([selectedOption]);
                      } else {
                        handleRaasiChange([]);
                      }
                    }}
                    required
                  >
                    <option value="">Select Raasi</option>
                    {raasiOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-section-title">Physical Attributes</div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Weight</label>
                  <select
                    className="form-control"
                    value={weight}
                    onChange={(e) => handleWeightChange(e.target.value)}
                    required
                  >
                    <option value="">Min-Max weight</option>
                    <option value="60">40-60 kg</option>
                    <option value="80">60-80 kg</option>
                    <option value="100">80-100 kg</option>
                    <option value="150">100-150 kg</option>
                    <option value="Any">Any</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Body Type</label>
                  <select
                    className="form-control"
                    value={food}
                    onChange={(e) => handleFoodChange(e.target.value)}
                    
                  >
                    <option value="">Body Type</option>
                    <option value="Slim">Slim</option>
                    <option value="Average">Average</option>
                    <option value="Athletic">Athletic</option>
                    <option value="Heavy">Heavy</option>
                    <option value="Any">Any</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-row">
              {/* <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Skin Color</label>
                  <select
                    className="form-control"
                    value={smoking}
                    onChange={(e) => handleSmokingChange(e.target.value)}
                    required
                  >
                    <option value="">Complexion</option>
                    <option value="Very Fair">Very Fair</option>
                    <option value="Fair">Fair</option>
                    <option value="Wheatish">Wheatish</option>
                    <option value="Wheatish Brown">Wheatish Brown</option>
                    <option value="Dark">Dark</option>
                    <option value="Any">Any</option>
                  </select>
                </div>
              </div> */}
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Physical Status</label>
                  <select
                    className="form-control"
                    value={drinking}
                    onChange={(e) => handleDrinkingChange(e.target.value)}
                   
                  >
                    <option value="">Physical Status</option>
                    <option value="Normal">Normal</option>
                    <option value="Physically Challenged">Physically Challenged</option>
                    <option value="Any">Any</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate("/modern-religious-info")}
            >
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Complete Profile
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernPartnerPreferenceDetails;
